





























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import IInboundDocument from '@/store/models/IInboundDocument';
import IListCustomPaper from '@/store/models/IListCustomPaper';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import vue2Dropzone from 'vue2-dropzone';
import { v4 as uuidv4 } from 'uuid';
@Component({
    components: {
        vueDropzone: vue2Dropzone
    }
})
export default class InboundDocument extends Vue {
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    InboundDocuments !: IInboundDocument[];
    @Prop({ type: Array, required: true })
    InboundDocumentsCompanyDestination !: IInboundDocument[];
    @Prop({ type: Array, required: true })
    InboundDocumentsCompanySource !: IInboundDocument[];
    @Prop({ type: Array, required: true })
    CustomPaperList !: IListCustomPaper[];
    @Prop({ type: String, required: true })
    InboundCode !: String;
    @Prop()
    CompanySourceName !: String;
    @Prop()
    CompanyDestinationName !: String;

    selectedCustomPaper: IListCustomPaper[] = [];
    currFiles: any[] = [];
    files: any[] = [];
    selectedDocumentSourceCompany: any[] = [];
    selectedDocumentDestinationCompany: any[] = [];
    dropzoneOptions: any = {
        url: 'http://localhost',
        thumbnailWidth: 150,
        maxFilesize: 25,
        headers: { "My-Awesome-Header": "header value" },
        addRemoveLinks: true,
        maxFiles: 10,
        previewsContainer: false
    }

    appendLocation(file: any) {
        this.files.push(file);
    }
	
    onMaxFilesReached(files: any[]) {
        this.$emit("showMessageWarning", "A maximum of 10 files may be uploaded.");
        if (files.length > 10) {
            files.slice(10).forEach((file) => {
                this.remove(file);
            });
        }
    }

    download(item: IInboundDocument) {
        this.$emit("downloadInboundDocument", item);
    }

    deleteInboundDocument(item: IInboundDocument) {
        this.$emit("deleteInboundDocument", item);
    }

    remove(index: number) {
        this.files.splice(index, 1);
        // this.currFiles.splice(index, 1);
    }

    inputChanged() {
        this.files = [
            ...this.currFiles, ...this.files
        ];
    }

    uploadFiles() {
        if (!this.files) {
            this.$emit("showMessageWarning", "Please select a file");
        }
        if (this.files.length === this.selectedCustomPaper.length) {
            let formDatas : FormData = this.getFormData();
            let fileNames : string[] = [];
            for (let i in this.files) {
                fileNames.push(this.sanitizeFileName(this.files[i].name));
            }
            
            this.$emit('uploadInboundDocument', formDatas, fileNames, this.selectedCustomPaper);
            this.currFiles = [];
            this.selectedCustomPaper = [];
            const dropzoneComponent = this.$refs.myVueDropzone as any;
            if (dropzoneComponent && typeof dropzoneComponent.removeAllFiles === 'function') {
                dropzoneComponent.removeAllFiles();
            }
            this.files = [];
        } else {
            this.$emit("showMessageWarning", "Please select for all documents a document type.");
        }
    }

    sanitizeFileName(fileName: string): string {
        return fileName
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9._-]/g, "_")
        .replace(/_{2,}/g, "_")
        .replace(/^_+|_+$/g, "");
    }

    getFormData () : FormData {
        let formData = new FormData();
        for (let file of this.files) {
            let name = uuidv4();
            formData.append("files", file, name);
        }
        return formData;
    }
}
